import Input from "components/inputs";
import { useTranslation } from "react-i18next";

const Rules = ({ onChangeRules }) => {
  const { t } = useTranslation();
  const rules = <>{t("pma-onboarding.accept-contract-rules")}</>;

  return (
    <div className="mb-3 ">
      <Input
        onChange={onChangeRules}
        name="rules"
        type="checkbox"
        checkboxContent={rules}
      />
    </div>
  );
};
export default Rules;
